import { styled, apply } from 'lib/styled'

export const ErrorMessage = styled.div(apply('flex-1 text-red text-xs'))
